import React from 'react'
import "../styles/services.css"
import JoinSamoolah from '../components/Home/JoinSamoolah'
import Navbar from '../components/Navbar'

const FormApp = () => {
  return (
    <div>
      <Navbar />
      <JoinSamoolah />
    </div>
  )
}

export default FormApp